// extracted by mini-css-extract-plugin
module.exports = {"container":"_1M5mqHFXBQfPp8zo04hbdo"};